<nav class="footer navbar-expand-lg" style="min-width: 350px;">
    <div class="container-fluid">
        <div class="row justify-content-center align-items-center mt-4">
            <div class="col-12 col-md-4 text-center order-2 order-md-1">
                <div class="container">
                    <div class="row justify-content-center align-items-center">
                        <div class="col-12 mb-1">
                            <span style="font-size: small; font-weight: bold;">{{"FOOTER.ABOUTUS" | translate}}</span>
                        </div>
                        <div class="col-12">
                            <span style="font-size: small;">
                                Weco S.R.L.
                            </span>
                        </div>
                        <div class="col-12">
                            <span style="font-size: small;">
                                Viale J.F. Kennedy 113, 50038
                            </span>
                        </div>
                        <div class="col-12">
                            <span style="font-size: small;">
                                Scarperia e San Piero (FI)
                            </span>
                        </div>
                        <div class="col-12">
                            <span style="font-size: small;">
                                P.I. e C.F. 06567530487
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-4 mt-2 order-1 order-md-2 text-center">
                <div class="container">
                    <div class="row justify-content-center align-items-center">
                        <div class="col-12 mb-3">
                            <img src="assets/img/logo.png" class="footerLogo">
                        </div>
                        @if(lang == 'it'){
                          <div class="col-12">
                            <a href="https://www.iubenda.com/privacy-policy/52431611" target="_blank" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Privacy Policy ">Privacy Policy</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>
                            <br>
                            <a href="https://www.iubenda.com/termini-e-condizioni/52431611" target="_blank" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Termini e Condizioni ">Termini e Condizioni</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>
                          </div>
                        }
                        @else{
                          <div class="col-12">
                            <a href="https://www.iubenda.com/privacy-policy/78584924" target="_blank" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Privacy Policy ">Privacy Policy</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>
                            <br>
                            <a href="https://www.iubenda.com/terms-and-conditions/78584924" target="_blank" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Terms and Conditions ">Terms and Conditions</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>
                          </div>
                        }

                    </div>
                </div>
            </div>

            <div class="col-12 col-md-4 text-center order-3 mt-2 mt-md-0">
                <div class="container">
                    <div class="row justify-content-center align-items-center">
                        <div class="col-12 mb-1">
                            <span style="font-size: small; font-weight: bold;">{{"FOOTER.CONTACTUS" | translate}}</span>
                        </div>
                        <div class="col-12">
                            <span style="font-size: small;">
                                Mail: service&#64;wecobatteries.com
                            </span>
                        </div>
                        <div class="col-12 mb-3">
                            <span style="font-size: small;">
                                PEC: weco&#64;pec-legal.it
                            </span>
                        </div>
                        <div class="col-4 text-right">
                            <a href="https://wecobatteries.com/" target="_blank">
                                <i class="bi bi-browser-chrome icon-lg"></i>
                            </a>
                        </div>
                        <div class="col-4 text-center">
                            <a href="https://it.linkedin.com/company/weco-fze?trk=public_profile_experience-item_profile-section-card_subtitle-click"
                                target="_blank">
                                <i class="bi bi-linkedin icon-lg"></i>
                            </a>
                        </div>
                        <div class="col-4 text-left">
                            <a href="https://www.youtube.com/@wecolithiumbatteries7925" target="_blank">
                                <i class="bi bi-youtube icon-lg"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center align-items-center">
            <div class="col-12 text-center">
                <span style="font-size: x-small;">Powered by <a href="https://wallnet.it/"
                        target="_blank">Wallnet</a></span>
            </div>
        </div>
    </div>
</nav>
